import { User } from '../models/entities/User';

const ITEM_KEY = 'user';

export class UserStore {
  public fromCache(): User | undefined {
    const item = this.storage.getItem(ITEM_KEY);

    if (item != null) {
      // TODO: ちゃんと型チェックしたいが後回し
      const parsed = JSON.parse(item);
      return parsed;
    }

    return undefined;
  }

  public cache(user: User) {
    this.storage.setItem(ITEM_KEY, JSON.stringify(user));
  }

  public clear() {
    this.storage.removeItem(ITEM_KEY);
  }

  private get storage() {
    return window.sessionStorage;
  }
}
